module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Words.f018b133.txt";